import type { SociedadRank } from '../api'

// "owner" es el valor interno — desde Fase 2.7 es un rango de Empresa
// (Empresa.owner_user_id), no una fila en user_sociedad, pero /auth/me lo
// sigue exponiendo igual por Sociedad. La UI en español siempre lo muestra
// como "Dueño".
export const RANK_LABELS: Record<SociedadRank, string> = {
  owner: 'Dueño',
  administrador: 'Administrador',
  operador: 'Operador',
}

export const RANK_BADGE_VARIANT: Record<SociedadRank, 'default' | 'secondary' | 'outline'> = {
  owner: 'default',
  administrador: 'secondary',
  operador: 'outline',
}
